import React from "react";

const Element = React.forwardRef(({ id, isSelected, children, isAd }, ref) => {
    return (
        <li
            key={id}
            ref={ref}
            className={
              "p-3" +
              (isSelected ? ' selected' : '') +
              (id % 2 ? ' odd' : ' even')
            }
            style={ isAd ? {border: '2px dashed orange'} : {}}
        >
            {children}
        </li>
    )
})

export {
    Element
}